export const environment = {
  production: true,
  build_VersionNumber: '4.0.4-008',
  region: 'us',
  serviceUrl: 'https://ankota.net/WebAPIMobile/',
  documentUrl: 'https://ankota.net/WebAPIMobile/Documents/',
  APP_ID: '23301f7d33410ec',
  REGION: 'US',
  API_KEY: 'de6291205e15cf7db62132c442dfcc39210942f7',
  REST_KEY: 'adcdcc09689fc6207c2c2be4b4dcc6e66d4e545f',
  OPENAI_API_KEY: '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',
  PORT: 5058,
  XAI_API_KEY: 'xai-cRiCd4OtDD7079DGzgCsfPUKfYAGwp3MInHwv3wMEnOorYAdRYThnpDpdvIDrbz8BWpufpMeryRrNwwl'
};
